const leagueData = {
  standingsImageUrl:
    "https://pzht.pl/wp-content/uploads/2026/05/Tabela_1liga-1-1.png",
  officialPageUrl: "https://pzht.pl/i-liga/",
  lastUpdated: "2026-06-05",
  matches: [
    {
      id: "r1",
      round: 1,
      date: "2025-09-07",
      opponent: "UKH Start 1954 Gniezno",
      isHome: false,
      status: "result",
      scoreFor: 0,
      scoreAgainst: 14,
    },
    {
      id: "r2",
      round: 2,
      date: "2025-09-13",
      opponent: "KS Lipno Steszew",
      isHome: false,
      status: "result",
      scoreFor: 1,
      scoreAgainst: 9,
    },
    {
      id: "r3",
      round: 3,
      date: "2025-09-20",
      opponent: "LKS Gasawa",
      isHome: true,
      status: "result",
      scoreFor: 0,
      scoreAgainst: 15,
    },
    {
      id: "r4",
      round: 4,
      date: "2025-09-27",
      opponent: "MKS Sroda Wielkopolska",
      isHome: false,
      status: "result",
      scoreFor: 2,
      scoreAgainst: 3,
    },
    {
      id: "r5",
      round: 5,
      date: "2025-10-04",
      opponent: "KS Polonia Skierniewice",
      isHome: false,
      status: "result",
      scoreFor: 1,
      scoreAgainst: 5,
    },
    {
      id: "r6",
      round: 6,
      date: "2025-10-11",
      opponent: "UKS SP5 Swarek Swarzedz",
      isHome: false,
      status: "result",
      scoreFor: 6,
      scoreAgainst: 8,
    },
    {
      id: "r7",
      round: 7,
      date: "2025-10-18",
      opponent: "UKS Orleta Sosnowiec-Gornik",
      isHome: false,
      status: "result",
      scoreFor: 1,
      scoreAgainst: 6,
    },
    {
      id: "r9",
      round: 9,
      date: "2025-11-08",
      opponent: "UKS Osemka Tarnowskie Gory",
      isHome: false,
      status: "result",
      scoreFor: 1,
      scoreAgainst: 5,
    },
    {
      id: "r10",
      round: 10,
      date: "2026-03-28",
      opponent: "UKS Osemka Tarnowskie Gory",
      isHome: true,
      status: "result",
      scoreFor: 0,
      scoreAgainst: 2,
    },
    {
      id: "r11",
      round: 11,
      date: "2026-04-11",
      opponent: "HK Lipno Steszew",
      isHome: true,
      status: "result",
      scoreFor: 1,
      scoreAgainst: 2,
    },
    {
      id: "r12",
      round: 12,
      date: "2026-04-18",
      opponent: "LKS Gasawa",
      isHome: false,
      status: "result",
      scoreFor: 1,
      scoreAgainst: 12,
    },
    {
      id: "r13",
      round: 13,
      date: "2026-04-25",
      opponent: "MKS Sroda Wielkopolska",
      isHome: true,
      status: "result",
      scoreFor: 2,
      scoreAgainst: 3,
    },
    {
      id: "r14",
      round: 14,
      date: "2026-05-09",
      opponent: "KS Polonia Skierniewice",
      isHome: true,
      status: "result",
      scoreFor: 3,
      scoreAgainst: 6,
    },
    {
      id: "r15",
      round: 15,
      date: "2026-05-16",
      opponent: "UKS SP5 Swarek Swarzedz",
      isHome: true,
      status: "result",
      scoreFor: 3,
      scoreAgainst: 4,
    },
    {
      id: "r16",
      round: 16,
      date: "2026-05-23",
      opponent: "UKS Orleta Sosnowiec-Gornik",
      isHome: true,
      status: "result",
      scoreFor: 3,
      scoreAgainst: 1,
    },
    {
      id: "r18",
      round: 18,
      date: "2026-06-06",
      opponent: "UKH Start 1954 Gniezno",
      isHome: true,
      status: "scheduled",
      time: "18:00",
    },
  ],
};

export default leagueData;
